import { Reveal, SectionTag } from "./Reveal";

const CHARACTERS = [
  { name: "ARIA", img: "/assets/char_aria.jpg", trait: "Warm, witty and endlessly curious about your day." },
  { name: "NOVA", img: "/assets/char_nova.jpg", trait: "Playful energy with a sharp sense of humour." },
  { name: "SELENE", img: "/assets/char_selene.jpg", trait: "Calm, sophisticated and quietly perceptive." },
  { name: "IRIS", img: "/assets/char_iris.jpg", trait: "Bold, adventurous and always up for something new." },
];

export default function Characters() {
  return (
    <section data-testid="characters-section" className="relative bg-[#0a0a0a] py-16 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <SectionTag>AI Characters</SectionTag>
          <h2 className="font-display mt-5 max-w-xl text-3xl font-light tracking-tighter text-white sm:text-4xl lg:text-5xl">
            Meet the <span className="text-cyan-300">AI Characters</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#C5CBD5]">
            A first look at the kind of photorealistic companions the platform is being built
            around — each with a distinct appearance and personality.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CHARACTERS.map(({ name, img, trait }, i) => (
            <Reveal key={name} delay={0.08 * i}>
              <div data-testid={`character-card-${name.toLowerCase()}`} className="group">
                <div className="relative overflow-hidden rounded-xl border border-white/10">
                  <img
                    src={img}
                    alt={`${name} — AI-generated fictional character, concept visual`}
                    className="aspect-[3/4] w-full object-cover object-top transition-transform duration-[1.2s] ease-out group-hover:scale-[1.05]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-5">
                    <p className="font-display text-lg font-medium tracking-[0.15em] text-white">{name}</p>
                    <p className="mt-1.5 text-[13px] leading-relaxed text-[#C5CBD5]">{trait}</p>
                  </div>
                </div>
                <p className="mt-3 text-[10px] uppercase tracking-[0.22em] text-white/55">
                  AI-generated fictional character
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
